// src/utils/formatHelpers.js
import { Timestamp } from "firebase/firestore";

export const formatDateTime = (timestamp) => {
  if (!timestamp) return "N/A";
  try {
    const date = timestamp instanceof Timestamp ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "N/A";
  }
};

export const formatDate = (timestamp) => {
  if (!timestamp) return "N/A";
  try {
    const date = timestamp instanceof Timestamp ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return "N/A";
  }
};

export const formatDateShort = (timestamp) => {
  if (!timestamp) return "N/A";
  try {
    const date = timestamp instanceof Timestamp ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
    });
  } catch {
    return "N/A";
  }
};

export const formatDateFull = (timestamp) => {
  if (!timestamp) return "N/A";
  try {
    const date = timestamp instanceof Timestamp ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString("en-GB", {
      weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  } catch {
    return "N/A";
  }
};

export const formatTime = (timestamp) => {
  if (!timestamp) return "N/A";
  try {
    const date = timestamp instanceof Timestamp ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "N/A";
  }
};

export const calculateDuration = (start, end) => {
  if (!start || !end) return null;
  try {
    const startDate = start instanceof Timestamp ? start.toDate() : new Date(start);
    const endDate = end instanceof Timestamp ? end.toDate() : new Date(end);
    const diffMs = endDate - startDate;
    const diffMins = Math.floor(diffMs / 60000);
    const hours = Math.floor(diffMins / 60);
    const mins = diffMins % 60;
    return hours > 0 ? `${hours}h ${mins}m` : `${mins}m`;
  } catch {
    return null;
  }
};
